import axios from 'axios';

const VALIDATE_VOUCHER_URL =
    'https://personal-d4yby5if.outsystemscloud.com/Booking_API/rest/Vouchers/ValidateCode';

function parseVoucherValidateResponse(raw) {
    if (raw === true || raw === 'true' || raw === 'True' || raw === 1) return true;
    if (raw === false || raw === 'false' || raw === 'False' || raw === 0) return false;

    if (typeof raw === 'string') {
        const trimmed = raw.trim().toLowerCase();
        if (trimmed === 'true') return true;
        if (trimmed === 'false') return false;
    }

    if (raw && typeof raw === 'object') {
        const nested =
            raw.Result ??
            raw.result ??
            raw.Valid ??
            raw.valid ??
            raw.IsValid ??
            raw.isValid;
        if (nested !== undefined) return parseVoucherValidateResponse(nested);
    }

    return false;
}

export async function validateVoucherCode(code) {
    const response = await axios.get(VALIDATE_VOUCHER_URL, {
        params: { Code: code.trim() }
    });
    return parseVoucherValidateResponse(response.data);
}
